/*
 * Convergence.BrandPageLogo
 *
 * On a brand category page (e.g. /Shop_by_Brand/domestic-power) replaces the page title
 * with the "Brand image" from the "shop By categories and brands" custom record.
 * If the brand has no image (or the page is not a brand page) the title is left unchanged.
 *
 * Data source: the existing ShopByCatBrand extension service (same call the home page
 * "Shop by Brands" tab makes). If that extension's version changes, update SERVICE_PATH.
 */
define('Convergence.BrandPageLogo', [
	'jQuery',
	'underscore'
], function (
	jQuery,
	_
) {
	'use strict';

	// SelectedCategoriesID=1 -> "Brands" list; SelectedCategoriesint_id=5 -> same value the home page uses
	var SERVICE_PATH = '/scs/extensions/Convergence/ShopByCatBrand/1.0.0/services/ShopByCatBrand.Service.ss';
	var SERVICE_PARAMS = { SelectedCategoriesID: 1, SelectedCategoriesint_id: 5 };
	var HEADING_SELECTOR = '.facets-browse-category-heading-main-description h1';

	var brandsRequest = null;

	// "/Shop_by_Brand/Domestic-Power/?page=2" -> "/shop_by_brand/domestic-power"
	function normalizePath(url) {
		var path = String(url || '').replace(/^#!?/, '').replace(/[?#].*$/, '');
		path = ('/' + path).replace(/\/+/g, '/').replace(/\/$/, '');
		return path.toLowerCase();
	}

	// Loads the brand list once per page load and caches it as { normalizedUrl: { image, name } }
	function loadBrands() {
		if (!brandsRequest) {
			var env = (window.SC && SC.ENVIRONMENT) || {};
			var params = _.extend({}, SERVICE_PARAMS, {
				c: env.companyId,
				n: env.siteSettings && env.siteSettings.siteid
			});

			brandsRequest = jQuery.ajax({ url: SERVICE_PATH, data: params, dataType: 'json' })
				.then(function (response) {
					var brands = {};
					_.each((response && response.recordRes) || [], function (record) {
						if (record.fullurl && record.custrecord_cv_shop_by_cat_image) {
							brands[normalizePath(record.fullurl)] = {
								image: record.custrecord_cv_shop_by_cat_image,
								name: record.name
							};
						}
					});
					return brands;
				}, function () {
					// Service unavailable: keep the normal text titles
					return jQuery.Deferred().resolve({}).promise();
				});
		}
		return brandsRequest;
	}

	// Current category URL: from the PLP component when available, otherwise from the address bar
	function getCurrentPath(container) {
		var plp = container.getComponent('PLP');
		var category = plp && plp.getCategoryInfo && plp.getCategoryInfo();
		if (category && category.fullurl) {
			return normalizePath(category.fullurl);
		}
		var hash = window.location.hash;
		return normalizePath(hash && hash.length > 1 ? hash : window.location.pathname);
	}

	// Longest brand URL that the current path starts with (so facet/paging URLs still match)
	function findBrand(brands, path) {
		var match = null;
		_.each(brands, function (brand, url) {
			if ((path === url || path.indexOf(url + '/') === 0) && (!match || url.length > match.url.length)) {
				match = { url: url, brand: brand };
			}
		});
		return match && match.brand;
	}

	function showLogo(container) {
		var $heading = jQuery(HEADING_SELECTOR);
		if (!$heading.length || $heading.find('.brand-page-logo-image').length) {
			return;
		}
		var path = getCurrentPath(container);

		loadBrands().done(function (brands) {
			var brand = findBrand(brands, path);
			if (!brand) {
				return; // not a brand page, or no brand image: keep the text title
			}
			var name = jQuery.trim($heading.text()) || brand.name;
			var $img = jQuery('<img class="brand-page-logo-image" />').attr({ src: brand.image, alt: name });
			var $text = jQuery('<span class="brand-page-logo-text"></span>').text(name);
			$heading.empty().append($img, $text);
		});
	}

	return {
		mountToApp: function mountToApp(container) {
			var layout = container.getComponent('Layout');
			if (!layout) {
				return;
			}
			loadBrands();
			layout.on('afterShowContent', function () {
				showLogo(container);
			});
		}
	};
});
